import { Action } from '@ngrx/store';
import {BatteryTestModel, BatteryTestParams} from '../battery-test.model';

export enum BatteryTestStatusActionTypes {
  LoadBatteryTestStatuss = '[BatteryTestStatus] Load BatteryTestStatuss',
  GetBatteryTestStatuss = '[BatteryTestStatus] Get BatteryTestStatuss',
  GetBatteryTestStatussFail = '[BatteryTestStatus] Get BatteryTestStatuss Fail',
  StartBatteryTest = '[BatteryTestStatus] Start BatteryTest',
  GetDelayBatteryTestStatuss = '[BatteryTestStatus] Get Delay BatteryTestStatuss',

}

export class LoadBatteryTestStatuss implements Action {
  readonly type = BatteryTestStatusActionTypes.LoadBatteryTestStatuss;
  constructor(public payload: BatteryTestModel) {}
}

export class GetBatteryTestStatuss implements Action {
  readonly type = BatteryTestStatusActionTypes.GetBatteryTestStatuss;
  constructor(public payload: BatteryTestParams) {}
}

export class GetBatteryTestStatussFail implements Action {
  readonly type = BatteryTestStatusActionTypes.GetBatteryTestStatussFail;
}

export class StartBatteryTest implements Action {
  readonly type = BatteryTestStatusActionTypes.StartBatteryTest;
  constructor(public payload: BatteryTestParams) {}
}

export class GetDelayBatteryTestStatuss implements Action {
  readonly type = BatteryTestStatusActionTypes.GetDelayBatteryTestStatuss;
  constructor(public payload: BatteryTestParams) {}
}

export type BatteryTestStatusActions = LoadBatteryTestStatuss
  | GetBatteryTestStatuss
  | GetBatteryTestStatussFail
  | StartBatteryTest
  | GetDelayBatteryTestStatuss;
